import { NgModule } from '@angular/core';
import { AccountSharingPageComponent } from './account-sharing-page/account-sharing-page.component';
import { CommonModule } from '@angular/common';
import { SafeUrlPipeModule } from '../pipes/safe-url.pipe';

@NgModule({
  imports: [CommonModule, SafeUrlPipeModule],
  exports: [AccountSharingPageComponent],
  declarations: [AccountSharingPageComponent],
  entryComponents: [AccountSharingPageComponent],
})
export class AccountSharingModule {}



// WEBPACK FOOTER //
// ./ts/app/account-sharing/account-sharing.module.ts